document.addEventListener("DOMContentLoaded", function () {
  switchCheckbox();
});

function switchCheckbox() {
  const currentPath = decodeURIComponent(window.location.pathname);
  const tagsNamePath = currentPath.split("/")?.slice(3)?.join("/")?.split("+");
  tagsNamePath?.forEach(function (tagName) {
    const checkedGenre = document.getElementById("genre_" + tagName);
    if (checkedGenre) {
      checkedGenre.checked = true;
    }
    if (tagName == "") {
      document.getElementById("genre_").checked = true;
    }
    const checkedTag = document.getElementById("tag_" + tagName);
    if (checkedTag) {
      checkedTag.checked = true;
    }
  });
  const collectionName = currentPath?.split("/")?.[2];
  if (collectionName != "all" || currentPath == "/collections/all/VR") {
    console.log("collection名がallではない場合、他ページからの遷移のため、チェックボックスをONにします");
    document.getElementById("genre_VR").checked = true;
    document.getElementById("is-checked-genre-vr").style.display = "block";
  }
  const checkedMaker = collectionName == "all" ? null : document.getElementById("maker_" + collectionName);
  if (checkedMaker) {
    checkedMaker.checked = true;
  }
  const filterdProductCount = document.getElementById("pc-paginate-items")?.innerText;
  document.getElementById("mobile-paginate-items").innerText = filterdProductCount;
}
function productGenreFiltering({ device }) {
  // "genre_VR"が選択された場合のみ特定のアクションを実行
  if (document.getElementById("genre_VR")?.checked) {
    document.getElementById("is-checked-genre-vr").style.display = "block";
    // return;
  } else {
    // "genre_VR"以外が選択された場合、特定の要素を非表示にする
    document.getElementById("is-checked-genre-vr").style.display = "none";
  }
  const inputs = document.querySelectorAll("aside input");
  inputs.forEach(function (input) {
    if (input.id !== "genre_" + device) {
      input.disabled = true;
      input.checked = false;
    }
  });
  const redirectPath = `/collections/all/${device}`;
  console.log({ redirectPath });
  sectionRefetch({ redirectPath });
}


function productMakerFiltering({ maker }) {
  const tagsNamePath = decodeURIComponent(window.location.pathname).split("/")?.slice(3)?.join("/");
  // tagsNamePathから devices に存在する項目を削除
  const devices = [...document.querySelectorAll("aside label[class='filtering-genre-label']")]?.map(function (device) {
    return device.innerText;
  });
  console.log({ devices });
  const currentTagNames = tagsNamePath?.split("+")?.filter(tag => !devices.includes(tag))?.join("+");
  const redirectPath = `/collections/${maker}/${currentTagNames}`;
  console.log({ redirectPath });
  sectionRefetch({ redirectPath });
}


function productTagFiltering({ tagName }) {
  const currentPath = decodeURIComponent(window.location.pathname);
  const newCollectionPath = currentPath?.split("/")?.slice(0, 3)?.join("/") || "";
  const tagsNamePath = currentPath.split("/")?.slice(3)?.join("/");
  const radioButton = document.getElementById("tag_" + tagName);
  let currentTagNames = tagsNamePath?.split("+") || [];
  if (!radioButton.checked) {
    currentTagNames = currentTagNames.filter(tag => tag !== tagName);
  } else {
    currentTagNames.push(tagName);
  }
  currentTagNames = currentTagNames.join("+");
  const redirectPath = `${newCollectionPath}/${currentTagNames}`;
  console.log({ redirectPath });
  sectionRefetch({ redirectPath });
}


async function sectionRefetch({ redirectPath }) {
  try {

    const gridContent = document.getElementById("custom-collection-product-grid-content");
    // gridContent はローディングにする
    gridContent.innerHTML = loadingElement();
    // asideタグの中の input タグを全て取得し、disabled にする
    const inputs = document.querySelectorAll("aside input");
    inputs.forEach(function (input) {
      input.disabled = true;
    });
    console.log({ redirectPath });
    // redirectPaht にスペースがあれば、スペースを削除する
    let response = await fetch(redirectPath).catch(function (error) {
      console.error("エラーが発生しました", error);
    });
    if (response.ok === false) {
      console.log("ハイフンを削除して再度リクエストを送信します");
      response = await fetch(redirectPath.replace(/-/g, ""));
    }

    console.log({ response });
    const fetchedUrl = decodeURIComponent(new URL(response.url));
    history.pushState(null, '', fetchedUrl);
    console.log({ fetchedUrl });
    const html = await response.text();
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, 'text/html');
    const newContent = newDocument.getElementById(`custom-collection-product-grid-content`);
    gridContent.innerHTML = newContent?.innerHTML || "";

    inputs.forEach(function (input) {
      input.disabled = false;
    });
    const filterdProductCount = newDocument.getElementById("pc-paginate-items")?.innerText;
    console.log({ filterdProductCount });
    document.getElementById("mobile-paginate-items").innerText = filterdProductCount;

  } catch (error) {
    console.error("エラーが発生しました", error.message);
  }
}




function loadingElement() {
  return `
  <div class="loading-wrap">
  <div class="loading">
  <svg viewBox="0 0 30 30" role="img" aria-label="loading">
    <rect rx="1.5" x="13.5" class="loading-path _no1"/>
    <rect rx="1.5" transform="rotate(45 22.425 7.576)" x="20.925" y="3.075" class="loading-path _no2"/>
    <rect rx="1.5" transform="rotate(90 25.5 15)" x="24" y="10.5" class="loading-path _no3"/>
    <rect rx="1.5" transform="rotate(-45)" x="-1.5" y="28" class="loading-path _no4"/>
    <rect rx="1.5" x="13.5" y="21" class="loading-path _no5"/>
    <rect rx="1.5" transform="rotate(45)" x="19.5" y="6" class="loading-path _no6"/>
    <rect rx="1.5" transform="rotate(90 4.5 15)" x="3" y="10.5" class="loading-path _no7"/>
    <rect rx="1.5" transform="rotate(135 7.576 7.575)" x="6.075" y="3.075" class="loading-path _no8"/>
   </svg>
  </div>
</div>
<style>
.loading-wrap {
  margin-top: 50px;
}
.loading {
  width: 65px;
  height: 65px;
  margin: auto;
}
.loading-path {
  animation: fadeColor infinite .8s reverse;
  width: 3px;
  height: 9px;
  fill: #d4e0e8;
}
.loading-path._no1 {
  animation-delay: 0.1s;
}
.loading-path._no2 {
  animation-delay: 0.2s;
}
.loading-path._no3 {
  animation-delay: 0.3s;
}
.loading-path._no4 {
  animation-delay: 0.4s;
}
.loading-path._no5 {
  animation-delay: 0.5s;
}
.loading-path._no6 {
  animation-delay: 0.6s;
}
.loading-path._no7 {
  animation-delay: 0.7s;
}
.loading-path._no8 {
  animation-delay: 0.8s;
}
@keyframes fadeColor {
  to {
      fill: #406B9D;
  }
}

</style>`
}

function toggleAccordion() {
  const accordionId = event.target.id;
  const panel = document.querySelector(`[data-accordion-id="${accordionId}"]`);
  const arrow = document.querySelector(`#${accordionId} .accordion-arrow`);
  if (panel) {
    if (panel.style.maxHeight !== "0px" || panel.style.maxHeight === "100%") {
      panel.style.maxHeight = "0px";
      panel.style.marginTop = "0px";
      arrow.style.transform = "rotate(0deg)";
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.style.marginTop = "16px";
      arrow.style.transform = "rotate(180deg)";
    }
  }
}


function toggleFiltering() {
  console.log("toggleFiltering");
  const filteringContent = document.querySelector("aside.custom-collection-products-filtering");
  if (filteringContent) {
    if (filteringContent.classList.contains("active")) {
      filteringContent.classList.remove("active");
    } else {
      filteringContent.classList.add("active");
    }
  }
}